import API from '@/api';

class PaymentMethod
{

  /**
   * Get list of payment methods
   *
   * @return {promise}
   */
  static async getList() {
    return await API.dispatch(
      'GET',
      'paymentMethods',
      {
        query: {
          recent: true
        }
      }
    );
  }

  /**
   * Get payment method by ID
   *
   * @return {promise}
   */
  static async get(id) {
    return await API.dispatch(
      'GET',
      'paymentMethod',
      {
        path: {
          id
        }
      }
    );
  }

  /**
   * Setup payment method with parameters
   *
   * @return {promise}
   */
  static async setup(data) {
    return await API.dispatch(
      'POST',
      'setupPaymentMethods',
      {
        data
      },
      {
        'Content-Type': 'application/json'
      }
    );
  }

  /**
   * Store payment method with parameters
   *
   * @return {promise}
   */
  static async store(params) {
    return await API.dispatch(
      'POST',
      'paymentMethods',
      {
        data: params
      },
      {
        'Content-Type': 'application/json'
      }
    );
  }

  /**
   * Update payment method by ID with parameters
   *
   * @return {promise}
   */
  static async update(id, params) {
    return await API.dispatch(
      'PATCH',
      'paymentMethod',
      {
        path: { id },
        data: params
      }
    );
  }

  /**
   * Delete payment method by ID
   *
   * @return {promise}
   */
  static async delete(id) {
    return await API.dispatch(
      'DELETE',
      'paymentMethod',
      {
        path: { id }
      }
    );
  }

}

export default PaymentMethod;